import { CreativeTypes } from '@/models/Creative'

export const MenuTypes = {
  Geo: 'geo',
}

export const MenuTypeNames = {
  [MenuTypes.Geo]: 'ジオターゲティング',
}

export const BannerSizes = {
  _320x50: '320x50',
  _300x250: '300x250',
}

export const BannerSizeNames = {
  [BannerSizes._320x50]: '320 x 50',
  [BannerSizes._300x250]: '300 x 250',
}

export const PointGroupType = {
  OEM: 'OEM',
  ADVERTISER: 'ADVERTISER',
  IO: 'IO',
}

export const MenuTargets = {
  VISITOR: 'visitor',
  RESIDENT: 'resident',
}

export const Phases = {
  QUEUED: 'queued',
  RUNNING: 'running',
  CACHED: 'cached',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REJECTED: 'rejected',
}

export const SimulationResultHeaders = {
  GROUP: 'group',
  RADIUS: 'radius',
  UU: 'uu',
  IMPS: 'imps',
  CLICKS: 'clicks',
  CTR: 'ctr',
  REVENUE: 'revenue',
}

export const Steps = {
  BASIC: 1,
  DELIVERY: 2,
  ADVANCED: 3,
}

/** シミュレーション可能なメニュータイプの一覧 */
export const SimulatableMenuTypes = [MenuTypes.Geo]

/** シミュレーション可能なクリエイティブタイプの一覧 */
export const SimulatableCreativeTypes = [
  CreativeTypes.BANNER,
  CreativeTypes.INFEED,
]
